export default __webpack_public_path__ + "static/media/customer-image.1234d940.png";